import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'search-bar',
  templateUrl: 'search-bar.component.html',
  styleUrls: ['search-bar.component.scss'],
  standalone: false
})
export class SearchBarComponent {
  @Output()
  onChange: EventEmitter<any> = new EventEmitter();
  @Input()
  searchText: string;
  @Input() placeholder: string = '';
  @Input() iconDirection: string = '';

  emitTextChanged() {
    if (this.searchText != undefined) {
      this.onChange.emit(this.searchText);
    }
  }
}
